import React from "react";

type ApartmentIconProps = {
  size?: number | string;        // width & height
  color?: string;                // fill color
  className?: string;            // custom classes
};

const ApartmentIcon: React.FC<ApartmentIconProps> = ({
  size = 24,
  color = "#191C21",
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M8.06909 6.45535H9.47534V7.8616H8.06909V6.45535Z" fill={color} />
      <path d="M8.06909 9.68301H9.47534V11.0893H8.06909V9.68301Z" fill={color} />
      <path d="M14.5247 9.68301H15.9309V11.0893H14.5247V9.68301Z" fill={color} />
      <path d="M17.7522 9.68301H19.1584V11.0893H17.7522V9.68301Z" fill={color} />
      <path d="M14.5247 12.9107H15.9309V14.317H14.5247V12.9107Z" fill={color} />
      <path d="M17.7522 12.9107H19.1584V14.317H17.7522V12.9107Z" fill={color} />
      <path d="M14.5247 16.1384H15.9309V17.5446H14.5247V16.1384Z" fill={color} />
      <path d="M17.7522 16.1384H19.1584V17.5446H17.7522V16.1384Z" fill={color} />
      <path d="M14.5247 19.3661H15.9309V20.7723H14.5247V19.3661Z" fill={color} />
      <path d="M17.7522 19.3661H19.1584V20.7723H17.7522V19.3661Z" fill={color} />
      <path d="M4.84155 9.68301H6.2478V11.0893H4.84155V9.68301Z" fill={color} />
      <path d="M8.06909 12.9107H9.47534V14.317H8.06909V12.9107Z" fill={color} />
      <path d="M4.84155 12.9107H6.2478V14.317H4.84155V12.9107Z" fill={color} />
      <path d="M8.06909 16.1384H9.47534V17.5446H8.06909V16.1384Z" fill={color} />
      <path d="M4.84155 16.1384H6.2478V17.5446H4.84155V16.1384Z" fill={color} />
      <path
        d="M22.3861 22.5938V6.45534H12.7031V3.10078L11.0893 3.36975V0H3.22767V4.68005L1.61386 4.94902V22.5938H0V24H24V22.5938H22.3861ZM20.9799 7.86159V22.5938H12.7031V7.86159H20.9799ZM4.63392 1.40625H9.68302V3.60413L4.63392 4.44567V1.40625ZM3.02011 6.1403L11.2969 4.76081V6.45534V22.5938H9.47545V19.3661H4.84153V22.5938H3.02011V6.1403ZM8.0692 22.5938H6.24778V20.7723H8.0692V22.5938Z"
        fill={color}
      />
    </svg>
  );
};

export default ApartmentIcon;
